import { createStore, combineReducers } from 'redux'

import changeState from './reducers/state'
// 1 - Import additional reducers here


// 2 - Combine each of the additional reducers below:
const mainReducer = combineReducers({ changeState })

const store = createStore(mainReducer)

export default store

// **Attention : 3 - Since combineReducers is bein used, when referencing the reducers, we have to specify which one to call: e.g.: state.changeState.sidebarShow
// https://stackoverflow.com/questions/64845649/redux-is-not-working-while-using-combine-reducer

